import GetProductsMapper from './DXP/GetProductsMapper'
import GetPricingMapper from './MID/GetPricingMapper'
import SaveForeignHealthMapper from './MID/SaveForeignHealthMapper'

export default {
  GetProductsMapper,
  GetPricingMapper,
  SaveForeignHealthMapper
}
